import React from 'react'

function Footer() {
    return (
        <div className='footer'>
            <div className="container">
                <div className="left">
                    <h2>Our Links</h2>
                    <ul className='links'>
                        <a href="#">Facebook</a>
                        <a href="#">Instagram</a>
                        <a href="#">Youtube</a>
                        <a href="#">Tiktok</a>
                    </ul>
                </div>
                <div className="center">
                    <h2>Our Services</h2>
                    <ul className='services'>
                        <li>Shipping</li>
                        <li>Lorem, dolor.</li>
                        <li>Contact Support</li>
                        <li>Lorem, ipsum </li>
                    </ul>
                </div>
                <div className="right">
                    <h2>Our Company</h2>
                    <ul className='company'>
                        <a href='#'>Abullah Praga</a>
                        <a href='#'>giza, egpt</a>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Footer